/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateTriggeredActionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'
import {CreateTriggeredActionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'


export const createTriggeredAction = (request: CreateTriggeredActionRequest, options?: CashRequestOptions) => post<CreateTriggeredActionRequest, CreateTriggeredActionResponse>("/2.0/cash/create-triggered-action", request, {...options, rejectOnError: true })